import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface PrimaryArea {
  name: string;
  slug: string;
}

/**
 * Fetches the primary area for a place (is_primary = true, area status = public).
 * Returns null if no primary area is linked.
 */
export function usePrimaryArea(placeId: string | undefined) {
  return useQuery<PrimaryArea | null>({
    queryKey: ["primary-area", placeId],
    enabled: Boolean(placeId),
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("place_areas")
        .select("areas!inner(name, slug)")
        .eq("place_id", placeId!)
        .eq("is_primary", true)
        .limit(1)
        .maybeSingle();

      if (error) {
        console.error("[usePrimaryArea]", error);
        return null;
      }

      if (!data?.areas) return null;

      const area = data.areas as unknown as { name: string; slug: string };
      return { name: area.name, slug: area.slug };
    },
  });
}
